import { render, staticRenderFns } from "./AdSpaceSelectItem.vue?vue&type=template&id=6aea312a&scoped=true&"
import script from "./AdSpaceSelectItem.vue?vue&type=script&lang=ts&"
export * from "./AdSpaceSelectItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aea312a",
  null
  
)

export default component.exports